import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, CreditCard, Cpu } from "lucide-react";
import { HERO_BG, SERVICES, PARTNERS } from "../data/mock";

const iconMap = {
  sparkles: Sparkles,
  "credit-card": CreditCard,
  cpu: Cpu,
};

export default function Home() {
  return (
    <div>
      {/* HERO */}
      <section
        className="relative min-h-[560px] lg:min-h-[640px] flex items-center justify-center text-white"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-[44px] font-semibold leading-tight max-w-4xl mx-auto">
            Draw in and engage your users with the power of contactless technology.
          </h1>
          <div className="mt-10">
            <Link
              to="/contact-us"
              className="inline-block bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-widest text-sm px-10 py-4 rounded transition-all hover:shadow-xl"
            >
              GET STARTED
            </Link>
          </div>
        </div>
      </section>

      {/* SERVICE CARDS */}
      <section className="bg-[#f4f5f7] py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
            {SERVICES.map((s) => {
              const Icon = iconMap[s.icon];
              return (
                <div
                  key={s.title}
                  className="bg-white rounded-sm shadow-sm hover:shadow-xl transition-shadow duration-300 p-10 flex flex-col items-center text-center"
                >
                  <div className="w-16 h-16 rounded-full bg-[#29abe2]/10 flex items-center justify-center mb-5">
                    <Icon className="w-8 h-8 text-[#29abe2]" />
                  </div>
                  <h3 className="text-2xl font-semibold text-slate-800 mb-5">{s.title}</h3>
                  <p className="text-slate-600 text-[15px] leading-relaxed mb-8 flex-1">
                    {s.desc}
                  </p>
                  {s.external ? (
                    <a
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-widest text-[13px] px-8 py-3 rounded transition-colors"
                    >
                      {s.cta.toUpperCase()}
                    </a>
                  ) : (
                    <Link
                      to={s.href}
                      className="inline-block bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-widest text-[13px] px-8 py-3 rounded transition-colors"
                    >
                      {s.cta.toUpperCase()}
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* PARTNERS CAROUSEL */}
      <section className="bg-[#f4f5f7] pb-20 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="relative">
            <div className="flex gap-14 animate-marquee">
              {[...PARTNERS, ...PARTNERS].map((src, i) => (
                <div
                  key={i}
                  className="flex-shrink-0 w-48 h-28 flex items-center justify-center grayscale hover:grayscale-0 transition-all opacity-80 hover:opacity-100"
                >
                  <img src={src} alt="partner" className="max-h-full max-w-full object-contain" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
